export default function cycleUp(index, count) {
    return (index + 1) % count;
}
